<template>
  <section id="teknopedia" class="py-16 bg-blue-600">
    <div class="container mx-auto px-5 lg:px-6 max-w-[1380px]">
      <h2
        class="text-3xl font-bold text-center text-white mb-4"
        data-aos="fade-down"
      >
        Teknopedia
      </h2>
      <div class="mb-8" data-aos="fade-up" data-aos-delay="200">
        <p class="text-white text-base max-w-2xl mx-auto text-justify">
          Teknopedia adalah kumpulan sumber informasi digital untuk mendukung
          aktivitas mahasiswa UTDI. Temukan akses e-learning, hymne kampus,
          galeri fasilitas, dan organisasi mahasiswa di sini.
        </p>
      </div>
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
      >
        <!-- E-Learning Card -->
        <a
          href="https://elearning.utdi.ac.id"
          target="_blank"
          data-aos="fade-up"
          data-aos-delay="300"
          class="group"
        >
          <div
            class="bg-white p-8 rounded-2xl shadow-md text-center hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 ease-in-out h-full flex flex-col border border-gray-100"
          >
            <div class="flex-shrink-0 mb-6">
              <div
                class="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto group-hover:bg-blue-100 transition-colors duration-300"
              >
                <AcademicCapIcon
                  class="h-10 w-10 text-blue-600 group-hover:text-blue-700 transition-colors duration-300"
                />
              </div>
            </div>
            <div class="flex-grow">
              <h3
                class="font-bold text-gray-800 text-xl mb-3 group-hover:text-blue-700 transition-colors duration-300"
              >
                E-Learning
              </h3>
              <p class="text-gray-600 text-sm leading-relaxed">
                Platform pembelajaran digital UTDI untuk akses materi kuliah
                online
              </p>
            </div>
          </div>
        </a>

        <!-- Hymne Kampus Card -->
        <a
          href="https://www.youtube.com/watch?v=DGFmRbPJO5I"
          data-aos="fade-up"
          data-aos-delay="400"
          class="group"
        >
          <div
            class="bg-white p-8 rounded-2xl shadow-md text-center hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 ease-in-out h-full flex flex-col border border-gray-100"
          >
            <div class="flex-shrink-0 mb-6">
              <div
                class="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto group-hover:bg-blue-100 transition-colors duration-300"
              >
                <MusicalNoteIcon
                  class="h-10 w-10 text-blue-600 group-hover:text-blue-700 transition-colors duration-300"
                />
              </div>
            </div>
            <div class="flex-grow">
              <h3
                class="font-bold text-gray-800 text-xl mb-3 group-hover:text-blue-700 transition-colors duration-300"
              >
                Hymne Kampus
              </h3>
              <p class="text-gray-600 text-sm leading-relaxed">
                Dengarkan dan pelajari lagu kebanggaan Universitas Teknologi
                Digital
              </p>
            </div>
          </div>
        </a>

        <!-- Fasilitas Kampus Card -->
        <a
          href="https://www.youtube.com/watch?v=vhzJhGFkigY"
          data-aos="fade-up"
          data-aos-delay="500"
          class="group"
        >
          <div
            class="bg-white p-8 rounded-2xl shadow-md text-center hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 ease-in-out h-full flex flex-col border border-gray-100"
          >
            <div class="flex-shrink-0 mb-6">
              <div
                class="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto group-hover:bg-blue-100 transition-colors duration-300"
              >
                <BuildingOfficeIcon
                  class="h-10 w-10 text-blue-600 group-hover:text-blue-700 transition-colors duration-300"
                />
              </div>
            </div>
            <div class="flex-grow">
              <h3
                class="font-bold text-gray-800 text-xl mb-3 group-hover:text-blue-700 transition-colors duration-300"
              >
                Fasilitas Kampus
              </h3>
              <p class="text-gray-600 text-sm leading-relaxed">
                Jelajahi galeri ruang kelas modern, laboratorium, dan
                perpustakaan
              </p>
            </div>
          </div>
        </a>

        <!-- Ormawa Card -->
        <a href="#ormawa" data-aos="fade-up" data-aos-delay="600" class="group">
          <div
            class="bg-white p-8 rounded-2xl shadow-md text-center hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 ease-in-out h-full flex flex-col border border-gray-100"
          >
            <div class="flex-shrink-0 mb-6">
              <div
                class="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto group-hover:bg-blue-100 transition-colors duration-300"
              >
                <UsersIcon
                  class="h-10 w-10 text-blue-600 group-hover:text-blue-700 transition-colors duration-300"
                />
              </div>
            </div>
            <div class="flex-grow">
              <h3
                class="font-bold text-gray-800 text-xl mb-3 group-hover:text-blue-700 transition-colors duration-300"
              >
                Ormawa
              </h3>
              <p class="text-gray-600 text-sm leading-relaxed">
                Informasi lengkap organisasi kemahasiswaan dan kegiatan kampus
              </p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import {
  AcademicCapIcon,
  MusicalNoteIcon,
  BuildingOfficeIcon,
  UsersIcon,
} from "@heroicons/vue/24/outline";
</script>
